module.exports = __webpack_public_path__ + "media/images/pillar_grants-dc36d2f813d6124aad112cd7cc621483.jpg";